import type { PayloadAction, Slice } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ToastMessageProps } from '@standardsdigital/ui-components/Toast';

export type MessageState = ToastMessageProps[];

const initialState: MessageState = [];

export const messageSlice: Slice<MessageState> = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    showMessage(state, action: PayloadAction<Omit<ToastMessageProps, 'id'>>) {
      state.push({
        ...action.payload,
        id: state.length,
      });
    },
  },
});

export const { showMessage } = messageSlice.actions;

export default messageSlice.reducer;
